import React from "react";
import { Link } from "gatsby";
import { myContentInfo } from "../../my-content";

import TheWeather from "../components/TheWeather.js";

export default function Layout({ children }) {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer=window.dataLayer||[];
            function gtag(){dataLayer.push(arguments);} 
            gtag('js', new Date()); gtag('config', 'G-MTEN4YK6SL');`,
        }}
      />
      <div className="primary-wrap">
        {/* need wrapper to push footer flush  */}
        <div className="i-am-body-wrap i-am-responsive-container">
          <div className="navigation-bar">
            <div className="left">
              <div className="logo">
                <Link to="/">
                  <span>
                    <img src="/logo.png" alt={myContentInfo.websiteTitle} />
                  </span>
                  <strong>{myContentInfo.websiteTitle}</strong>
                </Link>
              </div>
            </div>
            <div className="right">
              <div className="main-nav">
                <Link
                  to="/news"
                  partiallyActive={true}
                  activeClassName="active-menu"
                >
                  <i className="fa-solid fa-newspaper"></i>
                  Latest News
                </Link>
                <Link
                  to="/statistics"
                  partiallyActive={true}
                  activeClassName="active-menu"
                >
                  <i className="fa-solid fa-arrow-up-wide-short"></i>
                  Statistic Leaders
                </Link>
                <Link
                  to="/roster"
                  partiallyActive={true}
                  activeClassName="active-menu"
                >
                  <i className="fa-solid fa-users-line"></i>
                  49ers Roster
                </Link>
              </div>
            </div>
          </div>

          <div className="top-tagger">
            <h2>
              A no-frills fan site for San Francisco 49ers providing the latest
              news and statistics.
            </h2>
          </div>

          <div>
            <div className="app-wrapper">{children}</div>
          </div>
        </div>

        <div className="footer">
          <div className="footer-inside i-am-responsive-container">
            <div className="left-side">
              <div className="footer-promo-box">
                <TheWeather></TheWeather>
              </div>
            </div>
            <div className="middle-side"></div>
            <div className="right-side">
              <div className="footer-promo-box">
                <div className="about-me">
                  <img src="/me.jpg" />
                  <div>
                    <h4>Contact Us</h4>
                    <p>
                      Hey! thanks for visiting my site and{" "}
                      <a href="mailto:the49ershub@gmail.com" target="_blank">
                        email me
                      </a>{" "}
                      with any requests.
                    </p>
                  </div>
                </div>
              </div>
              <div className="copyright">
                Copyright {new Date().getFullYear()}{" "}
                <img src="/helmet.png?19" /> the49ershub.com
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
